<template lang="pug">
#page_archive.page
	Banner(v-bind:item='item_banner', classes='half')
	.container.pt-5
		.row
			.col-md-4(v-for='item in items_archive')
				CardFull(v-bind:item='item', classes='')
</template>

<script>
import Banner from '@/components/Banner.vue';
import CardFull from '@/components/CardFull.vue';
export default {
	data() {
		return {
			item_banner: {
				media: 'assets/images/banner_1.jpg',
				title: this.$t('nav_about_archive'),
			},
			items_archive: [
				{
					image: 'assets/images/archive/archive_9.png',
					title: this.$t('archive_9_title'),
					desc: this.$t('archive_9_date'),
					link: 'https://www.pts.org.tw/ticff_2020onlineClone_films/',
				},
				{
					image: 'assets/images/archive/archive_8.png',
					title: this.$t('archive_8_title'),
					desc: this.$t('archive_8_date'),
					link: 'https://www.pts.org.tw/ticff_2018_films',
				},
				{
					image: 'assets/images/archive/archive_7.png',
					title: this.$t('archive_7_title'),
					desc: this.$t('archive_7_date'),
					link: 'https://www.pts.org.tw/ticff_2016_films/',
				},
				{
					image: 'assets/images/archive/archive_6.png',
					title: this.$t('archive_6_title'),
					desc: this.$t('archive_6_date'),
					link: 'https://www.pts.org.tw/ticff_2014_films/',
				},
				{
					image: 'assets/images/archive/archive_5.png',
					title: this.$t('archive_5_title'),
					desc: this.$t('archive_5_date'),
					link: 'http://activity.pts.org.tw/PTS/PTSTICFF/',
				},
				{
					image: 'assets/images/archive/archive_4.png',
					title: this.$t('archive_4_title'),
					desc: this.$t('archive_4_date'),
					link: 'http://web.pts.org.tw/~web02/childfilm/',
				},
				{
					image: 'assets/images/archive/archive_3.png',
					title: this.$t('archive_3_title'),
					desc: this.$t('archive_3_date'),
					link: 'http://web.pts.org.tw/~web01/kids_films/',
				},
				{
					image: 'assets/images/archive/archive_2.png',
					title: this.$t('archive_2_title'),
					desc: this.$t('archive_2_date'),
					link: 'http://web.pts.org.tw/~web01/kids_films2006/',
				},
				{
					image: 'assets/images/archive/archive_1.png',
					title: this.$t('archive_1_title'),
					desc: this.$t('archive_1_date'),
					link: 'http://web.pts.org.tw/~web01/kids_films2004/',
				},
			],
		};
	},
	watch: {
		'$i18n.locale'() {
			for (let i = 9; i > 0; i--) {
				this.items_archive[9 - i].title = this.$t(`archive_${i}_title`);
				this.items_archive[9 - i].desc = this.$t(`archive_${i}_date`);
			}
			this.item_banner.title = this.$t('nav_about_archive');
		},
	},
	components: {
		Banner,
		CardFull,
	},
};
</script>
